@if (showSearchForm) {
  <div>
    @if (title && renderTitle) {
      <his-heading [level]="hierarchyLevel" [value]="title | hisUi" />
    }
    <div class="clearer"></div>
    @if (widgetGroups) {
      <div class="searchFormContainer">
        <form [formGroup]="form" (keydown.enter)="enterOnForm($event)">
          @if (showSearchButton) {
            <button (click)="submitSearchForm()" class="hiddenButton"></button>
          }
          <div class="form-row genericSearchbuttonsTop" appScrollwithme>
            @if (showSearchButton) {
              <button (click)="submitSearchForm()" class="submitSearchFormButton">
                <span>{{ 'common.search' | hisUi }}</span>
              </button>
            }
            <button (click)="resetInputs(); $event.preventDefault();" class="resetInputsButton">
              <span>{{ 'common.reset' | hisUi }}</span>
            </button>
            @if (hasQuickSearchCriteria) {
              <button class="hasQuickSearchCriteriaButton" (click)="onToggleQuickSearch(); $event.preventDefault();">
                <span>{{ (showAllSearchCriteria) ? ('genericSearch.toggleSearchShowAllCriteria_showQuickSearch' | hisUi) : ('genericSearch.toggleSearchShowAllCriteria_showAll' | hisUi) }}</span>
              </button>
            }           
            <!-- Custom button -->
            <ng-content select="[customSearchButtons]"></ng-content>
            @if (searchShowSearchParamsBox) {
              <his-search-save-params
                [configFile]="configFile"
                [form]="form"
                [widgetGroups]="widgetGroups"
                [searchFormData]="this"
                [searchForm]="this"
                [callerId]="callerId">
              </his-search-save-params>
            }          
            <!-- Link to generic search help page.  -->
            @if (showLinkToSearchHelp) {
              <a class="transparent linkToSearchHelp" href="{{contextPath}}/pages/genericSearch/genericSearchHelp.faces" hisImage="INFORMATION" title="{{'genericSearch.help' | hisUi}} " rel="noopener" >{{'genericSearch.help' | hisUi}}</a>
            }
          </div>
         
          <div class="clearerSpaceAboveHalfEm"></div>
          <div class="layoutBlock">
            <!-- Linke Spalte -->
            <div class="columnHalfLeft">
              <his-search-form-column [form]="form"
                [showAllSearchCriteria]="showAllSearchCriteria"
                [widgetGroups]="widgetGroups.slice(0, searchMaskLeftGroupsAmount)"
                [headingLevelWidgetTitle]="headingLevelWidgetTitle">
              </his-search-form-column>
            </div>
            <!-- Rechte Spalte -->
            @if (widgetGroups.length > searchMaskLeftGroupsAmount) {
              <div class="columnHalfRight">
                <his-search-form-column [form]="form"
                  [showAllSearchCriteria]="showAllSearchCriteria"
                  [widgetGroups]="widgetGroups.slice(searchMaskLeftGroupsAmount)"
                  [headingLevelWidgetTitle]="headingLevelWidgetTitle">
                </his-search-form-column>
              </div>
            }
          </div>
        </form>
        @if (showFormData) {
          <div>
            <br>
            <strong>Form Data:</strong>
            <pre style="margin: 0px;">{{form.value | json}}</pre>
          </div>
        }
        <div #formSearchButtons class="form-row genericSearchbuttonsBottom">
          @if (showSearchButton) {
            <button type="submit" (click)="submitSearchForm()" class="submitSearchFormButton">
              <span>{{ 'common.search' | hisUi }}</span>
            </button>
          }
          <button (click)="resetInputs(); $event.preventDefault();" class="resetInputsButton">
            <span>{{ 'common.reset' | hisUi }}</span>
          </button>
          @if (hasQuickSearchCriteria) {
            <button class="hasQuickSearchCriteriaButton" (click)="onToggleQuickSearch(); $event.preventDefault();" >
              <span>{{ (showAllSearchCriteria) ? ('genericSearch.toggleSearchShowAllCriteria_showQuickSearch' | hisUi) : ('genericSearch.toggleSearchShowAllCriteria_showAll' | hisUi) }}</span>
            </button>
          }
          
          <!-- Custom buttons -->
          <ng-content select="[customSearchButtons]"></ng-content>
          <ng-content select="[customSearchSet]"></ng-content>
        </div>
      </div>
    }
  </div>
}
